import {Component, EventEmitter, Inject, Input} from '@angular/core';
import {HelpModel} from '@spout/global-web/models';
import {Observable, Subject} from 'rxjs';
import {CONTAINER_DATA, ContentModel} from '../content.model';

@Component({
  selector: 'spt-help-create-mix',
  templateUrl: './help-create-mix.component.html',
  styleUrls: ['./help-create-mix.component.scss']
})
export class HelpCreateMixComponent implements ContentModel {
  static ref = HelpModel.CREATE_MIX;
  static title = 'Mix Permissions For Tracks';

  showBackHeader = true;

  helpTitle = HelpCreateMixComponent.title;

  private modalClose: Subject<any> = new Subject();

  onModalClose(): Observable<any> {
    return this.modalClose.asObservable();
  }

  constructor(@Inject(CONTAINER_DATA) private data: ContentModel) {
    if (this.data) {
      this.showBackHeader = this.data.showBackHeader;
    }
  }

  closeModal() {
    this.modalClose.next(null);
    this.modalClose.complete();
  }
}
